import { render } from "./_LayoutFooter.vue?vue&type=template&id=d7090c60&scoped=true"
import script from "./_LayoutFooter.vue?vue&type=script&lang=js"
export * from "./_LayoutFooter.vue?vue&type=script&lang=js"

import "./_LayoutFooter.vue?vue&type=style&index=0&id=d7090c60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7090c60"]])

export default __exports__